import type { Quotation, QuotationStatus } from '~/api/quotations/types';

import { includes } from './arrays';

/** Status `Approved`, `Rejected` */
export const isApprovedOrRejected = (quotation: Quotation) =>
  includes(['Approved', 'Rejected'] satisfies QuotationStatus[], quotation.status);
